import { makeStyles, createStyles } from '@material-ui/core'

export const useDesktopStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        backgroundColor: theme.palette.bg.footerBg,
        boxShadow: '0px -2px 12px rgba(209, 212, 226, 0.4)',
        padding: '12px 0',

        '& *': {
          color: theme.palette.text.secondary,
          fontSize: 14
        }
      },

      container_auth: {
        alignItems: 'center',
        justifyContent: 'space-between'
      },

      container: {
        height: '44px',
        alignItems: 'center',
        justifyContent: 'space-around'
      },

      links: {
        '& > a': {
          position: 'relative',
          marginLeft: theme.spacing(1),
          paddingLeft: theme.spacing(1),
          color: theme.palette.text.primary,

          '&:not(:first-child)::before': {
            content: '"|"',
            position: 'absolute',
            left: 0,
            bottom: 1
          }
        }
      },

      text: {
        color: theme.palette.grey[300]
      }
    }),
  {
    name: 'FooterDesktop'
  }
)

export const useMobileStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        backgroundColor: theme.palette.bg.footerBg,
        padding: theme.spacing(2, 2)
      },

      content: {
        justifyContent: 'space-between',
        marginBottom: theme.spacing(0.5),

        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column'
        }
      },

      logo: {
        height: 44,
        maxWidth: 100,

        [theme.breakpoints.down('xs')]: {
          margin: '0 auto 10px auto'
        }
      },

      text: {
        textAlign: 'right',
        color: theme.palette.grey[300],

        [theme.breakpoints.down('xs')]: {
          textAlign: 'center'
        }
      },

      linksWrapper: {
        justifyContent: 'space-between',
        margin: theme.spacing(1.8, 0, 4, 0)
      },

      btns: {
        alignItems: 'flex-start',
        marginRight: '-12px',

        '& > *': {
          width: 45,
          height: 45
        }
      },

      copyrightWrapper: {
        '& *': {
          color: theme.palette.text.primary,
          fontSize: 14
        },

        '& a': {
          position: 'relative',
          marginLeft: theme.spacing(0.5),
          paddingLeft: theme.spacing(1),

          '&:first-child': {
            margin: 0
          },

          '&:not(:first-child)::before': {
            content: '"|"',
            position: 'absolute',
            left: 0,
            bottom: 25,
            color: theme.palette.text.hint,

            [theme.breakpoints.down('xs')]: {
              left: 0,
              bottom: 1
            }
          }
        },

        [theme.breakpoints.down('sm')]: {
          display: 'flex'
        },

        [theme.breakpoints.down('xs')]: {
          justifyContent: 'center'
        }
      }
    }),
  {
    name: 'FooterMobile'
  }
)
